export const callHeaders = [
  /* "OI", */ "Volume", /* "OI Change%", */ "Close", "Change%", "Change", "LTP"
];

export const putHeaders = [
  "LTP", "Change", "Change%", "Close", /* "OI Change%", */ "Volume" /*, "OI"*/
];

export const callGreekHeaders = [
  /* "Delta", "Gamma", "Theta", "Vega", "Rho", "IV", "OI Change%", "OI", */
  "Volume", "Close", "Change%", "Change", "LTP"
];

export const putGreekHeaders = [
  "LTP", "Change", "Change%", "Close", "Volume"
  /*, "OI", "OI Change%", "IV", "Rho", "Vega", "Theta", "Gamma", "Delta" */
];
